import React, { Component } from "react";
import { Async } from "react-select-plus";
import "react-select-plus/dist/react-select-plus.css";
import { connect } from 'react-redux'

import { get } from "../utils/apiService";

import { updateSelectedTags, resetFilter } from "../actions/tagFilter"

class TagFilter extends Component {
  constructor() {
    super();

    this.state = {
      value: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }
  handleChange(value) {
    this.setState({ value });

    let tags = value.map(val => {
      return val.value
    })

    this.props.updateSelectedTags(tags);
  }
  getOptions(input, callback) {
    this.props.resetFilter();
    let { campaign } = this.props;
    let url = `/campaigns/${campaign.id}/filters`;
    get(url).then(res => {
      let options = res.data.map(name => {
        return {
          label: name,
          value: name
        };
      });
      callback(null, {
        options: options
      });
    });
  }
  render() {
    const { value } = this.state;
    return (
      <Async
        multi
        name="form-field-name"
        value={value}
        onChange={this.handleChange}
        loadOptions={this.getOptions}
        closeOnSelect={false}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateSelectedTags: (selectedTags) => {
      dispatch(updateSelectedTags(selectedTags));
    },
    resetFilter: () => {
      dispatch(resetFilter());
    },
  };
};

export default connect(null, mapDispatchToProps)(TagFilter);



// WEBPACK FOOTER //
// ./src/components/TagFilter.js